module.exports = __webpack_public_path__ + "5abf07096756cdc8536ee524b41928e4.png";


//////////////////
// WEBPACK FOOTER
// ./src/views/Root/Nav/images/menu_yellow.png
// module id = ./src/views/Root/Nav/images/menu_yellow.png
// module chunks = 0